import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/Styles.scss";
import "./Cartpage.scss";

const CartPage = () => {
  const [Cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  let finalTotalAmount;

  useEffect(() => {
    fetchCartDetails();
  }, []);
  const fetchCartDetails = async () => {
    const id = localStorage.getItem("cart_id");
    if (id) {
      try {
        const response = await fetch(
          `https://web-production-e9268.up.railway.app/api/v1/payment/cart/view-cart/?cart_id=${id}`
        );
        const data = await response.json();
        setCart(data); // Update cart details
        console.log("Cart", data);
      } catch (error) {
        console.error("Error fetching cart details:", error);
      } finally {
        setLoading(false); // Set loading to false after fetch attempt
      }
    } else {
      setLoading(false);
    }
  };

  const handleRemove = async (item) => {
    const cart_id = localStorage.getItem("cart_id");
    const itemRemoveLink = `https://web-production-e9268.up.railway.app/api/v1/payment/cart/remove-item/`;
    if (cart_id) {
      try {
        const response = await fetch(itemRemoveLink, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cart_id: cart_id,
            product_id: item.product.id,
          }),
        });
        const data = await response.json();
        console.log("Item removed", data);
        fetchCartDetails();
      } catch (error) {
        console.error("Error removing item from cart:", error);
      }
    }
  };

  useEffect(() => {
    if (Cart?.items) {
      finalTotalAmount = Cart.items.reduce((sum, item) => {
        return sum + item.total_amount * item.quantity;
      }, 0);
    }
  }, [Cart]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="cart-container">
      <div className="cart-content">
        {/* Left Side: Cart Items */}
        <div className="left-content">
          <table className="cart-table">
            <thead className="">
              <tr>
                <th className="ps-3">Product</th>
                <th className="d-flex justify-content-end">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="2">
                  <div className="scrollable-product-list">
                    {Cart && Cart.items.length > 0 ? (
                      Cart.items.map((item, index) => {
                        const product = item.product;
                        const imageUrl =
                          product.images?.[0]?.image_url ||
                          "https://via.placeholder.com/150";
                        const variationArray =
                          product.variations_list[0].variation.split("x");
                        // console.log("variationArray", variationArray);
                        const material = variationArray[0] || "N/A";
                        const size = variationArray[1] || "N/A";
                        const price =
                          parseFloat(product.price_range.split("-")[0]) || 0;
                        const totalPrice = parseFloat(item.total_amount) || 0;

                        return (
                          <tr key={index}>
                            <td>
                              <div className="cart-item">
                                <img src={imageUrl} alt={product.title} />
                                <div className="item-details">
                                  <h5>{product.title}</h5>
                                  <p className="price">
                                    ${totalPrice.toFixed(2)}
                                  </p>
                                  <p className="sold-by">
                                    Sold by:{" "}
                                    {product.created_by?.username || "Unknown"}
                                  </p>
                                  <p>Material: {material}</p>
                                  <p>Size: {size}</p>
                                  <div className="quantity-controls">
                                    <button className="minus-btn">-</button>
                                    <input
                                      type="number"
                                      value={item.quantity}
                                      readOnly
                                    />
                                    <button className="plus-btn">+</button>
                                  </div>
                                  <button
                                    className="remove-item"
                                    onClick={() => handleRemove(item)}
                                  >
                                    Remove item
                                  </button>
                                </div>
                              </div>
                            </td>
                            <td className="vertical-top text-right">
                              ${(totalPrice * item.quantity).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="2">No items in the cart.</td>
                      </tr>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {Cart && Cart.items.length > 0 ? (
          <div className="cart-sidebar">
            <table className="cart-table w-100">
              <thead>
                <tr>
                  <th>Cart Total</th>
                </tr>
              </thead>
            </table>
            <div className="pricing">
              <div className="subtotal">
                <div className="pad-subtotal">
                  <span>Subtotal</span>
                  <strong>
                    $
                    {Cart.items
                      .reduce((sum, item) => {
                        return sum + item.total_amount * item.quantity;
                      }, 0)
                      .toFixed(2) || 0}
                  </strong>
                </div>
              </div>
              <div className="shipping">
                <div className="pad-subtotal">
                  <div>
                    <p className="m-0">Delivery</p>
                    <p className="f-12 m-0 pt-2">Free shipping</p>
                  </div>
                  <strong>Free</strong>
                </div>
                <div className="address">
                  <div className="pad-subtotal">
                    <p className="f-14 m-0">
                      Shipping to California, United States (US)
                    </p>
                  </div>
                </div>
                <div className="mt-3 px-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      defaultChecked
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault2"
                    >
                      Free Shipping
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="Total px-3">
              <h6 className="f-20 m-0">Total</h6>
              <p className="total-amount">
                $
                {Cart.items
                  .reduce((sum, item) => {
                    return sum + item.total_amount * item.quantity;
                  }, 0)
                  .toFixed(2) || 0}
              </p>
            </div>
            <Link to={`/Checkout`}>
              <button className="Checkout-btn">Proceed to Checkout</button>
            </Link>
          </div>
        ) : (
          <tr>
            <td colSpan="2">No items in the cart.</td>
          </tr>
        )}

        <div aria-hidden="true" className="wp-block-spacer"></div>
      </div>
    </div>
  );
};

export default CartPage;
